﻿import $ from "jquery";
import CcsLogoProgram from "logoProgram";

const rootClass = "ccs-logo-widget";

export default class LogoWidget {

	constructor($ep, model) {
		this.model = model;
		this.$root = $ep.data("widget", this);

		this.init();
	}

	init() {
		const _ = this,
			$root = _.$root,
			model = _.model;

		_.$wrap = $(`<div class='${rootClass}-wrap'>`);
		_.$outer = $(`<div class='${rootClass}-outer'>`);
		_.$inner = $(`<div class='${rootClass}-inner'>`);
		_.$header = $("<h3>").text(model.title);
		_.$container = $(`<div class='${rootClass}-container'>`);

		$root.append(
			_.$wrap.append(
				_.$outer.append(
					_.$inner.append(_.$header).append(_.$container))));

		_.resize();
	}

	resize(extraProcessing) {
		const _ = this,
			$root = _.$root,
			width = _.model.settings.width,
			height = _.model.settings.height;

		clearTimeout(_.resizeTimer);

		_.resizeTimer = setTimeout(() => {

			width && _.$outer.width(width);
			height && _.$outer.height(height);

			if ($.isFunction(extraProcessing)) {
				extraProcessing.call(_);
			}

			height && _.$outer.height(_.$inner.outerHeight(true));

			setTimeout(() => $root.one("ccsResize", () => _.resize()), 75);

			//this.i = (this.i++ || 0) + 1;
			//console.log(`[${this.i}] widget resize: ${this.$wrap.width()}x${this.$wrap.height()}`);
		}, 24);
	}

	buildProduct(index) {
		const _ = this;
		const product = _.model.products[index];

		return $(`<div class='${rootClass}-product'>`)
			.attr("data-index", index)
			.append(_.buildImage(product))
			.append(_.buildInfo(product));
	}

	buildImage(product) {
		return $(`<div class='${rootClass}-image'>`)
			.append(product.imageUrl && `<img src='${product.imageUrl}' alt=''>`);
	}

	buildInfo(product) {
		return $(`<div class='${rootClass}-info'>`)
			.append(this.buildTitle(product))
			.append(this.buildSellBlock(product));
	}

	buildTitle(product) {
		const settings = this.model.settings;

		let $titleContent;
		if (product.url) {

			$titleContent = $("<a>").attr("target", settings.target);

			const hideLink = settings.parsingPriceJs
				? settings.showLinkWithPrice
				: settings.showLinkWithPrice && !(product.price && product.price.value);

			if (hideLink) {
				$titleContent.attr("data-href", product.url);
			} else {
				$titleContent.attr("href", product.url);
				this.LoggingInit(product, $titleContent, "product");
			}
		} else {
			$titleContent = $("<span>");
		}

		$titleContent.text(product.name);

		return $(`<div class='${rootClass}-title'>`)
			.append($titleContent);
	}

	buildSellBlock(product) {
		if (!product.price && !product.cart) {
			return null;
		}

		return $(`<div class='${rootClass}-sell'>`)
			.append(this.buildPrice(product))
			.append(this.buildCart(product));
	}

	buildPrice(product) {
		const price = product.price;
		const settings = this.model.settings;

		if (!price && !settings.priceFallbackText) {
			return null;
		}

		const $price = $(`<div class='${rootClass}-price'>`);

		if (price && price.url) {
			$price.addClass("ccs-loading");

			this.requestPrice(product, $price);
		} else {
			$price.text(price && price.value || settings.priceFallbackText);
		}

		return $price;
	}

	requestPrice(product, $price) {
		const settings = this.model.settings;

		CcsLogoProgram.requestPrice(
			(data) => {
				if (data.result) {
					const val = data.result.trim();
					$price.text(val);
					product.price.value = val;

					var $product = $price.closest(`.${rootClass}-product`);

					var $addToCart = $product.find(`.${rootClass}-cart [data-logo-addtocart]`);

					if (!$addToCart.hasClass("ccs-logo-atc-shown")) {
						this.LoggingInit(product, $addToCart, "addtocart");
					}

					var $productLink = $product.find(`.${rootClass}-title a`);

					if (!$productLink.hasClass("ccs-logo-link-shown")) {
						$productLink
							.attr("href", $productLink.attr("data-href"))
							.removeAttr("data-href");
						this.LoggingInit(product, $productLink, "product");
					}
				} else {
					$price.text(settings.priceFallbackText);
				}

				$price.removeClass("ccs-loading");
			},
			product.price.url,
			settings.parsingPriceJs,
			product.price.errorEvent);
	}

	buildCart(product) {
		if (!product.cart) {
			return null;
		}

		const $cartContent = $(`<div class='${rootClass}-cart'>`)
			.html(product.cart.html);

		const settings = this.model.settings;

		const hideCart = settings.parsingPriceJs
			? settings.showAddToCartWithPrice
			: settings.showAddToCartWithPrice && !(product.price && product.price.value);

		if (!hideCart) {
			var $cartElement = $cartContent.find("[data-logo-addtocart]");
			this.LoggingInit(product, $cartElement, "addtocart");
		}

		return $cartContent;
	}

	LoggingInit(product, $element, eventType) {

		var shownClass =
			eventType === "addtocart"
			? "ccs-logo-atc-shown"
			: "ccs-logo-link-shown";

		const _ = this;

		$element
			.addClass(shownClass)
			.on("click", function () {

				const context = $.extend({ type: eventType, vertical: _.vertical }, product.logData);

				if (_.model.settings.parsingPriceJs) {
					context.dynamicPrice = true;
					context.price = product.price.value;
				}

				const params = {
					Action: "conversion",
					ActionContext: JSON.stringify(context)
				}

				_.logEvent(params);
			});
	}

	logNavigate(context) {
		if (typeof context === "object") {
			context = JSON.stringify(context);
		}

		const params = {
			Action: "navigate-content",
			ActionContext: context
		}

		this.logEvent(params);
	}

	logEvent(clientParams) {
		ccs_cc_log.dispatchEvent(this.model.logCall, clientParams);
	}
}
